// extracted by mini-css-extract-plugin
export default {"miner_view":"MinerViewBlock_miner_view__6UkOZ","volume":"MinerViewBlock_volume__xPHj2","params":"MinerViewBlock_params__1UIqK"};